export const getBEMCls = (block: string, element?: string, modifier?: string) =>
    element ? (modifier ? `${block}__${element}_${modifier}` : `${block}__${element}`) : block

export const getCls = (name: string) => (...arg: string[]) => getBEMCls(name, ...arg)
